import React, { Component } from 'react';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import ui from '../../../common/services/ui';
import { Panel, Button } from 'react-bootstrap';

const List = ({ t, onSelectChild, ...rest }) => {

	const columns = [
		{
			header: t('Child_FullName'),
			accessor: 'fullName',
			sortable: true
		},
		{
			header: t('Child_Gender'),
			accessor: 'gender',
			cell: (gender) => gender.name ? t(`GenderType_${gender.name}`) : "",
			sortable: true
		},
		{
			header: t('Child_DateOfBirth'),
			accessor: 'dateOfBirth',
			cell: (dateOfBirth) => (ui.formatDate(dateOfBirth))
		},
		{
			header: t('MoveLessons_Parent'),
			accessor: 'parent.fullName'
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => <Button bsStyle='primary' onClick={() => onSelectChild(row)}>{t('Common_Select')}</Button>
		}
	];

	return <Panel>
		<Panel.Body>
			<PagedEntitiesList columns={columns} {...rest} />
		</Panel.Body>
	</Panel>;
};

export default List;